<template>
    <div class="popup" @click="closeTipsPop">
        <popup-lottery></popup-lottery>
        <popup-reward-record v-if="popRecordShow"></popup-reward-record>
        <popup-friend v-if="popFriShow"></popup-friend>
        <popup-gift-card></popup-gift-card>
        <popup-entity></popup-entity>
        <popup-save-name></popup-save-name>
        <popup-code></popup-code>
        <!-- <popup-login-tips></popup-login-tips> -->
        <popup-share-tips></popup-share-tips>
        <popup-rule />
        <popup-power-info></popup-power-info>
        <popup-comm />
    </div>
</template>

<script>
import { mapMutations } from 'vuex';
import PopupComm from './popup-comm.vue';
import PopupRule from './popup-rule.vue';
import PopupGiftCard from './popup-gift-card.vue';
import PopupEntity from './popup-entity.vue';
import PopupSaveName from './popup-save-name.vue';
import PopupLottery from './popup-lottery.vue';
import PopupCode from './popup-code.vue';
import PopupFriend from './popup-friend.vue';
import PopupLoginTips from './popup-login-tips.vue';
import PopupShareTips from './popup-share-tips.vue';
import PopupRewardRecord from './popup-reward-record.vue';
import PopupPowerInfo from './popup-power-info.vue';

export default {
    name: 'popup',
    components: {
        PopupComm,
        PopupRule,
        PopupGiftCard,
        PopupEntity,
        PopupSaveName,
        PopupLottery,
        PopupCode,
        PopupFriend,
        PopupLoginTips,
        PopupShareTips,
        PopupRewardRecord,
        PopupPowerInfo
    },
    computed: {
        // 好友页弹窗
        popFriShow() {
            return this.$store.state.popup.friend;
        },
        // 中奖记录弹窗
        popRecordShow() {
            return this.$store.state.popup.rewardRecord;
        }
    },
    methods: {
        ...mapMutations(['HIDE_POPUP']),
        // 关闭提示弹窗
        closeTipsPop() {
            this.HIDE_POPUP('shareTips');
        }
    }
};
</script>

<style lang="less" scoped>
.popup {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 9999;
}
</style>
